import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/program-book.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { QueryParams } from '../../../../../../types/grid';
import Router from '../../../../../../navigation/router';
import { Link } from 'react-router-dom';
import { routes } from '../../../../../../navigation';
import { groupProgramAnswerForPlotV4 } from '../../../../../../helpers/programBook/helperPlotAnswersV4';
import { Button } from 'react-bootstrap';
import Loader from '../../../../../../components/Loader';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { ProgramBookDownloadApi, ProgramBookApi } from '../../../../../../services/end-points';
import sortingService from '../../../../../../services/sorting';
import { useAsyncDebounce } from 'react-table';
import AbaLineChartE from '../../../../../../components/graphic/chart/AbaLineChartE';
import { DateTimePicker } from 'react-widgets';
import { persistProgramBookDownload } from '../../../../../../store/actions/programBookDownload-actions';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export interface StateProps {
    programBooks: any;
    programBook: any;
    programBookAnswers: any;
    inProgressAnswers: any;
}

export interface DispatchProps {
    getProgramBooks: (param: QueryParams) => void;
    getProgramBookEntity: (id: string, isHidden: string) => void;
    getProgramBookAnswers: (param: QueryParams) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}
export interface Props extends StateProps, DispatchProps, OwnProps {}

export interface ProgramBookDownloadFormData {
    dateFrom?: any;
    dateTo?: any;
    isActiveOnly: any;
    programBook: any;
}

enum DownloadBackendStatus {
    CREATED = 1,
    DELETED = 2,
    PROCESSING = 3,
    DONE = 4,
    FAILED = 5,
}
type DownloadUiStatus = 'idle' | 'created' | 'processing' | 'done' | 'failed' | 'error';
const mapBackendStatusToUi = (status?: number): DownloadUiStatus => {
    switch (status) {
        case DownloadBackendStatus.CREATED:
            return 'created';
        case DownloadBackendStatus.PROCESSING:
            return 'processing';
        case DownloadBackendStatus.DONE:
            return 'done';
        case DownloadBackendStatus.FAILED:
            return 'failed';
        case DownloadBackendStatus.DELETED:
            return 'idle';
        default:
            return 'error';
    }
};

//const MemoPlot = React.memo(Plot);
const MemoAbaLineChartE = React.memo(AbaLineChartE);

const ProgramBookGraphScreen: React.FunctionComponent<Props> = (props: Props) => {
    const [isHidden, setIsHidden] = useState('0');
    const [clickedTarget, setClickedTarget] = useState(0); // >0 – define a target, -1 – reload all
    const [requestedTargets, setRequestedTargets] = useState<any[]>([]);

    const [dataGrouped, setDataGrouped] = useState<any>([]);
    const [dataCollected, setDataCollected] = useState(0);
    const [isLoad, setIsLoad] = useState(0);
    const [isNewSetOfData, setIsNewSetOfData] = useState(0);
    const [isHideButton, setIsHideButton] = useState<number[]>([]);
    const [isGetAnswers, setIsGetAnswers] = useState(0);
    const listData: any[] = [];
    const [collectedAnswers, setCollectedAnswers] = useState({ data: { list: listData } });

    // target is loading now, for spinner
    const [loadingTargetId, setLoadingTargetId] = useState<number | null>(null);
    const [groupedByTarget, setGroupedByTarget] = useState<Record<number, any>>({});
    const [dataCollectedAnswers, setDataCollectedAnswers] = useState<any[]>([]);
    const [answersByTargetId, setAnswersByTargetId] = useState<Record<number, any[]>>({});
    const [sectionFirst, setSectionFirst] = useState(false);
    const [sectionSecond, setSectionSecond] = useState(false);
    const [sectionNumber, setSectionNumber] = useState(1);
    const [globalFilters, setGlobalFilters] = React.useState({
        dateFrom: moment().add(-5, 'years').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
    });

    const dispatch = useDispatch();
    const {
        match: {
            params: { id },
        },
        programBooks,
        getProgramBooks,
        programBookAnswers,
        getProgramBookAnswers,
        programBook,
        getProgramBookEntity,
        inProgressAnswers,
    } = props;

    // ====================== DOWNLOAD ALL ======================
    const POLL_MS = 30_000;
    const [downloadStatus, setDownloadStatus] = useState<DownloadUiStatus>('idle');
    const [downloadEntity, setDownloadEntity] = useState<any>(null);
    const [downloadError, setDownloadError] = useState<string | null>(null);
    const pollTimerRef = React.useRef<number | null>(null);
    const isPollingRef = React.useRef(false);
    const waitingForFirstEntityRef = React.useRef(false);
    const downloadFiltersRef = React.useRef<ProgramBookDownloadFormData>({
        dateFrom: globalFilters.dateFrom,
        dateTo: globalFilters.dateTo,
        isActiveOnly: Number(isHidden) != 1,
        programBook: id,
    });

    useEffect(() => {
        downloadFiltersRef.current = {
            dateFrom: globalFilters.dateFrom,
            dateTo: globalFilters.dateTo,
            isActiveOnly: Number(isHidden) != 1,
            programBook: id,
        };
        waitingForFirstEntityRef.current = false;
    }, [globalFilters.dateFrom, globalFilters.dateTo, isHidden, id]);

    const stopDownloadPolling = React.useCallback(() => {
        if (pollTimerRef.current) {
            window.clearInterval(pollTimerRef.current);
            pollTimerRef.current = null;
        }
        isPollingRef.current = false;
    }, []);

    useEffect(() => {
        return () => stopDownloadPolling();
    }, [stopDownloadPolling]);

    const fetchLatestDownload = React.useCallback(async () => {
        try {
            const params = downloadFiltersRef.current;

            const res = await ProgramBookDownloadApi.getProgramBookDownloads({
                dateFrom: params.dateFrom,
                dateTo: params.dateTo,
                isActiveOnly: params.isActiveOnly,
                programBook: params.programBook,
            });
            const list = (res as any)?.data ?? [];

            const latest = Array.isArray(list)
                ? list.slice().sort((a, b) => {
                      const at = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
                      const bt = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
                      return bt - at || (b?.id ?? 0) - (a?.id ?? 0);
                  })[0]
                : null;

            if (!latest) {
                if (
                    waitingForFirstEntityRef.current ||
                    downloadStatus === 'created' ||
                    downloadStatus === 'processing'
                ) {
                    return;
                }

                setDownloadEntity(null);
                setDownloadStatus('idle');
                setDownloadError(null);
                stopDownloadPolling();
                return;
            }

            setDownloadEntity(latest);
            setDownloadError(null);

            waitingForFirstEntityRef.current = false;

            const uiStatus = mapBackendStatusToUi(latest.status);
            setDownloadStatus(uiStatus);

            if (uiStatus === 'done' || uiStatus === 'failed' || uiStatus === 'idle' || uiStatus === 'error') {
                stopDownloadPolling();
            }
        } catch (e) {
            setDownloadStatus('error');
            setDownloadError(e?.message ?? 'Failed to fetch export status');
            stopDownloadPolling();
        }
    }, [stopDownloadPolling, downloadStatus]);

    const startDownloadPolling = React.useCallback(() => {
        if (isPollingRef.current) return;
        isPollingRef.current = true;
        fetchLatestDownload();
        pollTimerRef.current = window.setInterval(() => {
            fetchLatestDownload();
        }, POLL_MS);
    }, [fetchLatestDownload]);

    useEffect(() => {
        fetchLatestDownload();
    }, [fetchLatestDownload, globalFilters.dateFrom, globalFilters.dateTo, isHidden, id]);

    useEffect(() => {
        if (downloadStatus === 'created' || downloadStatus === 'processing') {
            startDownloadPolling();
        }
        if (
            downloadStatus === 'done' ||
            downloadStatus === 'failed' ||
            downloadStatus === 'idle' ||
            downloadStatus === 'error'
        ) {
            stopDownloadPolling();
        }
    }, [downloadStatus, startDownloadPolling, stopDownloadPolling]);

    const onDownloadAll = React.useCallback(() => {
        setDownloadError(null);
        waitingForFirstEntityRef.current = true;
        setDownloadStatus('created');
        startDownloadPolling();

        dispatch(
            persistProgramBookDownload(
                {
                    dateFrom: globalFilters.dateFrom,
                    dateTo: globalFilters.dateTo,
                    isActiveOnly: Number(isHidden) != 1,
                    programBook: id,
                },
                {
                    resolve: () => {
                        fetchLatestDownload();
                    },
                    reject: (errorMessage: string) => {
                        stopDownloadPolling();
                        setDownloadStatus('failed');
                        setDownloadError(errorMessage);
                        toast.error(errorMessage);
                    },
                },
            ),
        );
    }, [
        dispatch,
        fetchLatestDownload,
        globalFilters.dateFrom,
        globalFilters.dateTo,
        id,
        isHidden,
        startDownloadPolling,
        stopDownloadPolling,
    ]);

    const isWaiting = downloadStatus === 'created' || downloadStatus === 'processing';
    const isDone = downloadStatus === 'done';
    const isFailed = downloadStatus === 'failed';

    const zipUrl = downloadEntity?.attach ?? downloadEntity?.zipUrl ?? null;

    const onChange = useAsyncDebounce((change) => {
        setGlobalFilters((prev) => ({ ...prev, [change.id]: change.value }));
        setSectionFirst(false);
        setSectionSecond(false);

        // Trigger to reload all open plots» with new data
        setClickedTarget(-1);
        setIsGetAnswers(1);
    }, 200);

    useEffect(() => {
        if (!programBook) {
            getProgramBookEntity(id, '1');
        }
    }, []);

    useEffect(() => {
        getProgramBookEntity(id, '1');
    }, [dataCollected, sectionNumber]);

    let inProgress = false;
    useEffect(() => {
        if (
            (sectionNumber == 1 && sectionFirst == false) ||
            (sectionNumber == 2 && sectionSecond == false) ||
            clickedTarget !== 0
        ) {
            if (programBook) {
                const { programMainCategories, ...res } = programBook;
                if (programMainCategories) {
                    Object.values(programMainCategories).map(async (section: any) => {
                        if (
                            (sectionNumber == 1 && section.title == 'Skill Acquisition') ||
                            (sectionNumber == 2 && section.title == 'Behavior Reduction')
                        ) {
                            section.programCategories = section.programCategories
                                ? !Array.isArray(section.programCategories)
                                    ? Object.values(section.programCategories)
                                    : section.programCategories
                                : [];
                            for (const domain of section.programCategories) {
                                domain.programCategories = domain.programCategories
                                    ? !Array.isArray(domain.programCategories)
                                        ? Object.values(domain.programCategories)
                                        : domain.programCategories
                                    : [];

                                for (const longTerm of domain.programCategories) {
                                    longTerm.programCategories = longTerm.programCategories
                                        ? !Array.isArray(longTerm.programCategories)
                                            ? Object.values(longTerm.programCategories)
                                            : longTerm.programCategories
                                        : [];

                                    const targets: number[] = [];

                                    for (const shortTerm of longTerm.programCategories) {
                                        shortTerm.programTargets = shortTerm.programTargets
                                            ? !Array.isArray(shortTerm.programTargets)
                                                ? Object.values(shortTerm.programTargets)
                                                : shortTerm.programTargets
                                            : [];

                                        for (const target of shortTerm.programTargets) {
                                            const targetId = target.id;

                                            // just click on See results
                                            const isSingleClick = clickedTarget > 0 && targetId === clickedTarget;

                                            // change dates
                                            const isReloadOpened =
                                                clickedTarget === -1 && isHideButton.includes(targetId);

                                            if (!isSingleClick && !isReloadOpened) {
                                                continue;
                                            }
                                            if (
                                                isSingleClick &&
                                                requestedTargets.find((obj: string | number) => obj === targetId)
                                            ) {
                                                continue;
                                            }

                                            targets.push(targetId);

                                            if (isSingleClick) {
                                                setRequestedTargets((prev) => [...prev, targetId]);
                                            }
                                        }
                                    }

                                    if (targets.length) {
                                        inProgress = true;
                                        setIsLoad(1);
                                        setIsGetAnswers(1);

                                        await ProgramBookApi.getProgramBookAnswersForPlot({
                                            ...{
                                                'programBook.id': programBook.id,
                                                dateFrom: globalFilters.dateFrom,
                                                dateTo: globalFilters.dateTo,
                                                programTarget: targets,
                                                'axios-retry': {
                                                    retries: 3,
                                                },
                                            },
                                            order: sortingService.makeOrder({}),
                                            page: 1,
                                            itemsPerPage: 100000,
                                            pagination: 1,
                                        })
                                            .then(async (response2) => {
                                                const ss: any[] = response2.data?.data
                                                    ? JSON.parse(response2.data?.data)
                                                    : [];

                                                // group by target
                                                const grouped: Record<number, any[]> = {};
                                                for (const ans of ss) {
                                                    const tid = ans.programTarget?.id;
                                                    if (!tid) continue;
                                                    if (!grouped[tid]) grouped[tid] = [];
                                                    grouped[tid].push(ans);
                                                }

                                                setAnswersByTargetId((prev) => {
                                                    const next = { ...prev };

                                                    // only that now loaded
                                                    for (const tid of targets) {
                                                        next[tid] = grouped[tid] ?? [];
                                                    }

                                                    return next;
                                                });

                                                setIsNewSetOfData(1);
                                                setIsLoad(0);

                                                setCollectedAnswers((prev) => ({
                                                    data: {
                                                        list: [...(prev.data.list ?? []), ...ss],
                                                    },
                                                }));
                                                setLoadingTargetId(null);
                                            })
                                            .catch((e) => {
                                                console.error(e);
                                                setLoadingTargetId(null);
                                            });
                                    } else {
                                        inProgress = true;
                                        setIsGetAnswers(1);
                                        const da: any = dataCollectedAnswers;
                                        setDataCollectedAnswers(da);
                                        setCollectedAnswers({ data: { list: da } });
                                    }
                                }
                            }
                        }
                    });
                    inProgress = false;
                }
                if (sectionNumber === 1) {
                    setSectionFirst(true);
                } else if (sectionNumber === 2) {
                    setSectionSecond(true);
                }

                // clear flag
                if (clickedTarget !== 0) {
                    setClickedTarget(0);
                }
            }
        } else {
            setDataCollected(1);
        }
    }, [
        programBook,
        sectionNumber,
        clickedTarget,
        globalFilters.dateTo,
        globalFilters.dateFrom,
        isHideButton,
        requestedTargets,
    ]);

    useEffect(() => {
        if (!programBook) return;

        const { groupedTargets, tree } = groupProgramAnswerForPlotV4(
            programBook,
            answersByTargetId,
            globalFilters,
            isHideButton,
            groupedByTarget,
        );

        setGroupedByTarget(groupedTargets);
        setDataGrouped(tree);

        setDataCollected(1);
        if (!isHideButton.length) {
            setIsLoad(0);
        }
        setIsNewSetOfData(0);
    }, [programBook, answersByTargetId, isNewSetOfData, globalFilters, isHideButton]);

    function renderPhaseInfo(phase: any) {
        return (
            <span key={'phaseItem' + phase?.id} className={styles.phaseItem}>
                <b>{phase?.title}:</b>{' '}
                {phase?.startDate ? moment(phase?.startDate, 'YYYY-MM-DD HH:mm:ss').format('ll') : ''}
                {phase?.endDate ? ' - ' + moment(phase?.endDate, 'YYYY-MM-DD HH:mm:ss').format('ll') : ''}
                {'; '}
            </span>
        );
    }

    return (
        <AdminLayout>
            {!programBook || inProgressAnswers ? <Loader /> : null}
            <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>PROGRAM BOOK RESULT</h2>
            </div>
            <div className={classNames(styles.wrapForm)}>
                <div className={styles.orderInfo}>
                    Student:
                    <Link
                        target="_blank"
                        to={Router.generate(routes.STUDENT_DETAIL, {
                            id: programBook?.student?.id,
                            tab: 'student-info',
                        })}
                    >
                        {programBook?.student?.firstName ? ' ' + programBook?.student?.firstName : ''}
                        {programBook?.student?.lastName ? ' ' + programBook?.student?.lastName : ''}
                    </Link>
                </div>

                <div className={classNames(styles.orderInfo, styles.sectionButton)}>
                    <Button
                        className={classNames(
                            'mr-2',
                            sectionNumber == 1 ? styles.sectionActiveButton : styles.sectionInActiveButton,
                        )}
                        variant="secondary"
                        onClick={() => {
                            setSectionNumber(1);
                            setDataCollected(0);
                            setRequestedTargets([]);
                        }}
                    >
                        Skill Acquisition Section
                    </Button>
                    <Button
                        className={classNames(
                            'mr-2',
                            sectionNumber == 2 ? styles.sectionActiveButton : styles.sectionInActiveButton,
                        )}
                        variant="secondary"
                        onClick={() => {
                            setSectionNumber(2);
                            setDataCollected(0);
                            setRequestedTargets([]);
                        }}
                    >
                        Behavior Reduction Section
                    </Button>
                </div>
                {isHidden == '0' ? (
                    <Button
                        className={classNames('mr-2', styles.seeAllTargetButton)}
                        variant="secondary"
                        onClick={() => {
                            setIsHidden('1');
                        }}
                    >
                        Click here to see active and hidden
                    </Button>
                ) : (
                    <Button
                        className={classNames('mr-2', styles.seeAllTargetButton)}
                        variant="secondary"
                        onClick={() => {
                            setIsHidden('0');
                        }}
                    >
                        Click here to see active only
                    </Button>
                )}

                <div className={styles.plotAnswerContainer}>
                    {dataCollected
                        ? dataGrouped.map((section: any) => {
                              return (sectionNumber == 1 && section.section.title == 'Skill Acquisition') ||
                                  (sectionNumber == 2 && section.section.title == 'Behavior Reduction') ? (
                                  <div
                                      key={'section-' + section.section.id}
                                      data-level="SE"
                                      className={styles.sectionContainer}
                                  >
                                      <h2>{section.section.title}</h2>
                                      <div className={styles.description}>{section.section.description}</div>
                                      <div>
                                          {section.dataDomain.map((domain: any, indexS: number) => (
                                              <div
                                                  key={'domain-' + domain.domain.id}
                                                  data-level="DO"
                                                  className={classNames(
                                                      styles.domainContainer,
                                                      isHidden === '0' && domain.domain.isHidden == true
                                                          ? styles.hiddenTarget
                                                          : {},
                                                  )}
                                              >
                                                  <h3>
                                                      {domain.domain.title}
                                                      {domain.domain.isHidden == true ? <b>(hidden)</b> : ''}
                                                  </h3>
                                                  <div className={styles.description}>{domain.domain.description}</div>
                                                  <div>
                                                      {domain.dataLongTerm.map((longTerm: any, indexD: number) => (
                                                          <div
                                                              key={'long-' + longTerm.longTerm.id}
                                                              data-level="LT"
                                                              className={classNames(
                                                                  styles.longTermContainer,
                                                                  isHidden === '0' && longTerm.longTerm.isHidden == true
                                                                      ? styles.hiddenTarget
                                                                      : {},
                                                              )}
                                                          >
                                                              <h4>
                                                                  {longTerm.longTerm.title}
                                                                  {longTerm.longTerm.isHidden == true ? (
                                                                      <b>(hidden)</b>
                                                                  ) : (
                                                                      ''
                                                                  )}
                                                              </h4>
                                                              <div className={styles.description}>
                                                                  {longTerm.longTerm.description}
                                                              </div>
                                                              <div>
                                                                  {longTerm.dataShortTerm.map(
                                                                      (shortTerm: any, indexL: number) => (
                                                                          <div
                                                                              key={'short-' + shortTerm.shortTerm.id}
                                                                              data-level="ST"
                                                                              className={classNames(
                                                                                  styles.shortTermContainer,
                                                                                  isHidden === '0' &&
                                                                                      shortTerm.shortTerm.isHidden ==
                                                                                          true
                                                                                      ? styles.hiddenTarget
                                                                                      : {},
                                                                              )}
                                                                          >
                                                                              <h5>
                                                                                  {shortTerm.shortTerm.title}
                                                                                  {shortTerm.shortTerm.isHidden ==
                                                                                  true ? (
                                                                                      <b>(hidden)</b>
                                                                                  ) : (
                                                                                      ''
                                                                                  )}
                                                                              </h5>
                                                                              <div className={styles.description}>
                                                                                  {shortTerm.shortTerm.description}
                                                                              </div>
                                                                              <div>
                                                                                  {shortTerm.answers.map(
                                                                                      (
                                                                                          targetAnswers: any,
                                                                                          index: number,
                                                                                      ) => {
                                                                                          const targetId =
                                                                                              targetAnswers.target.id;
                                                                                          const hasAnswers =
                                                                                              targetAnswers.answers
                                                                                                  .length > 0;
                                                                                          const isRequested = isHideButton.includes(
                                                                                              targetId,
                                                                                          );
                                                                                          const isLoadingThisTarget =
                                                                                              loadingTargetId ===
                                                                                              targetId;

                                                                                          if (
                                                                                              targetAnswers.events
                                                                                                  ?.length
                                                                                          ) {
                                                                                              console.log(
                                                                                                  'Events',
                                                                                                  targetAnswers.events,
                                                                                              );
                                                                                          }

                                                                                          return (
                                                                                              <div
                                                                                                  key={
                                                                                                      'target-' +
                                                                                                      targetAnswers
                                                                                                          .target.id
                                                                                                  }
                                                                                                  className={classNames(
                                                                                                      styles.targetContainer,
                                                                                                      isHidden ===
                                                                                                          '0' &&
                                                                                                          targetAnswers
                                                                                                              .target
                                                                                                              .isHidden ==
                                                                                                              true
                                                                                                          ? styles.hiddenTarget
                                                                                                          : {},
                                                                                                  )}
                                                                                              >
                                                                                                  <h6>
                                                                                                      {
                                                                                                          targetAnswers
                                                                                                              .target
                                                                                                              .title
                                                                                                      }
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .type == 2
                                                                                                          ? ', seconds'
                                                                                                          : ''}
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .isHidden ==
                                                                                                      true ? (
                                                                                                          <b>
                                                                                                              (hidden)
                                                                                                          </b>
                                                                                                      ) : (
                                                                                                          ''
                                                                                                      )}
                                                                                                  </h6>
                                                                                                  {targetAnswers.target
                                                                                                      .prompt &&
                                                                                                  (targetAnswers.target
                                                                                                      .type == 1 ||
                                                                                                      targetAnswers
                                                                                                          .target
                                                                                                          .type ==
                                                                                                          3) ? (
                                                                                                      <div
                                                                                                          className={
                                                                                                              styles.targetDescription
                                                                                                          }
                                                                                                      >
                                                                                                          Prompt:
                                                                                                          <b>
                                                                                                              {' ' +
                                                                                                                  targetAnswers
                                                                                                                      .target
                                                                                                                      .prompt}
                                                                                                          </b>
                                                                                                      </div>
                                                                                                  ) : null}
                                                                                                  <div
                                                                                                      className={
                                                                                                          styles.targetDescription
                                                                                                      }
                                                                                                  >
                                                                                                      {
                                                                                                          targetAnswers
                                                                                                              .target
                                                                                                              .description
                                                                                                      }
                                                                                                  </div>
                                                                                                  <div
                                                                                                      className={
                                                                                                          styles.phaseItems
                                                                                                      }
                                                                                                  >
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .isPhased &&
                                                                                                      targetAnswers
                                                                                                          .target
                                                                                                          .programTargetPhases
                                                                                                          .length ? (
                                                                                                          <div>
                                                                                                              <b>
                                                                                                                  Phases:
                                                                                                              </b>
                                                                                                          </div>
                                                                                                      ) : null}
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .isPhased
                                                                                                          ? targetAnswers.target.programTargetPhases?.map(
                                                                                                                (
                                                                                                                    phase: any,
                                                                                                                ) =>
                                                                                                                    renderPhaseInfo(
                                                                                                                        phase,
                                                                                                                    ),
                                                                                                            )
                                                                                                          : null}
                                                                                                  </div>

                                                                                                  {hasAnswers && (
                                                                                                      <MemoAbaLineChartE
                                                                                                          title={
                                                                                                              targetAnswers
                                                                                                                  .target
                                                                                                                  .title
                                                                                                                  ? targetAnswers
                                                                                                                        .target
                                                                                                                        .title
                                                                                                                  : 'No title'
                                                                                                          }
                                                                                                          yLabel="Answers"
                                                                                                          points={
                                                                                                              targetAnswers.formatAnswers
                                                                                                          }
                                                                                                          phases={
                                                                                                              targetAnswers.phases
                                                                                                          }
                                                                                                          events={
                                                                                                              targetAnswers.events
                                                                                                          }
                                                                                                          isShowHundred={
                                                                                                              targetAnswers
                                                                                                                  .target
                                                                                                                  .type ==
                                                                                                                  1 ||
                                                                                                              targetAnswers
                                                                                                                  .target
                                                                                                                  .type ==
                                                                                                                  3
                                                                                                          }
                                                                                                      />
                                                                                                  )}
                                                                                                  {!hasAnswers &&
                                                                                                      isRequested &&
                                                                                                      isLoadingThisTarget && (
                                                                                                          <div
                                                                                                              className={
                                                                                                                  styles.chartLoaderWrapper
                                                                                                              }
                                                                                                          >
                                                                                                              <div
                                                                                                                  className="spinner-border"
                                                                                                                  role="status"
                                                                                                              >
                                                                                                                  <span className="sr-only">
                                                                                                                      Loading...
                                                                                                                  </span>
                                                                                                              </div>
                                                                                                          </div>
                                                                                                      )}

                                                                                                  {!hasAnswers &&
                                                                                                      !isRequested && (
                                                                                                          <Button
                                                                                                              className={classNames(
                                                                                                                  'mr-2',
                                                                                                                  styles.seeAllTargetButton,
                                                                                                              )}
                                                                                                              variant="secondary"
                                                                                                              disabled={
                                                                                                                  isLoadingThisTarget
                                                                                                              }
                                                                                                              onClick={() => {
                                                                                                                  setIsHideButton(
                                                                                                                      (
                                                                                                                          prev: number[],
                                                                                                                      ) =>
                                                                                                                          prev.includes(
                                                                                                                              targetId,
                                                                                                                          )
                                                                                                                              ? prev
                                                                                                                              : [
                                                                                                                                    ...prev,
                                                                                                                                    targetId,
                                                                                                                                ],
                                                                                                                  );
                                                                                                                  setClickedTarget(
                                                                                                                      targetId,
                                                                                                                  );
                                                                                                                  setLoadingTargetId(
                                                                                                                      targetId,
                                                                                                                  );
                                                                                                              }}
                                                                                                          >
                                                                                                              {isLoadingThisTarget
                                                                                                                  ? 'Loading…'
                                                                                                                  : 'See results'}
                                                                                                          </Button>
                                                                                                      )}

                                                                                                  {!hasAnswers &&
                                                                                                      isRequested &&
                                                                                                      !isLoadingThisTarget &&
                                                                                                      !isLoad &&
                                                                                                      targetAnswers.isClickedAnsweredEmpty && (
                                                                                                          <div>
                                                                                                              This
                                                                                                              target has
                                                                                                              no answers
                                                                                                              yet.
                                                                                                          </div>
                                                                                                      )}
                                                                                              </div>
                                                                                          );
                                                                                      },
                                                                                  )}
                                                                              </div>
                                                                          </div>
                                                                      ),
                                                                  )}
                                                              </div>
                                                          </div>
                                                      ))}
                                                  </div>
                                              </div>
                                          ))}
                                      </div>
                                  </div>
                              ) : null;
                          })
                        : null}
                </div>

                <div className={styles.bulkExportCard}>
                    <div className={styles.bulkExportHeader}>
                        <div>
                            <div className={styles.bulkExportTitle}>Download graphs in bulk</div>
                            <div className={styles.bulkExportSubtitle}>
                                Generate a ZIP archive with all graphs for the selected filters.
                            </div>
                        </div>

                        <div>
                            <div className={classNames(styles.firstFilterBlock)}>
                                <div className={classNames(styles.itemFilterBlock, 'mb-3 mr-3')}>
                                    <span>From:</span>
                                    <DateTimePicker
                                        value={
                                            globalFilters && globalFilters.dateFrom
                                                ? moment(globalFilters.dateFrom).toDate()
                                                : undefined
                                        }
                                        onChange={(date: any) => {
                                            onChange({
                                                id: 'dateFrom',
                                                value: date ? moment(date).format('YYYY-MM-DD') : undefined,
                                            });
                                        }}
                                        time={false}
                                        date={true}
                                        format={'MMM D, YYYY'}
                                    />
                                </div>
                                <div className={classNames(styles.itemFilterBlock, 'mb-3 mr-3')}>
                                    <span>To: </span>
                                    <DateTimePicker
                                        value={
                                            globalFilters && globalFilters.dateTo
                                                ? moment(globalFilters.dateTo).toDate()
                                                : undefined
                                        }
                                        onChange={(date: any) => {
                                            onChange({
                                                id: 'dateTo',
                                                value: date ? moment(date).format('YYYY-MM-DD') : undefined,
                                            });
                                        }}
                                        time={false}
                                        date={true}
                                        format={'MMM D, YYYY'}
                                    />
                                </div>
                            </div>
                        </div>

                        <button
                            className={classNames('btn', 'btn-outline-info', styles.bulkExportButton)}
                            type="button"
                            disabled={isWaiting}
                            onClick={onDownloadAll}
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            <span className={styles.bulkExportButtonText}>
                                {isWaiting ? 'Preparing export…' : 'Download All'}
                            </span>
                        </button>
                    </div>

                    <div className={styles.bulkExportBody}>
                        {isWaiting && (
                            <div className={classNames(styles.bulkExportAlert, styles.alertInfo)}>
                                <div className={styles.alertTitle}>Please wait — your request is being processed.</div>
                                <div className={styles.alertText}>
                                    This may take up to ~5–15 minutes depending on the amount of data.
                                    <br />
                                    Once it’s ready, a download link to the ZIP file will appear here automatically.
                                </div>

                                <div className={styles.progressLine} />
                            </div>
                        )}

                        {isDone && zipUrl && (
                            <div className={classNames(styles.bulkExportAlert, styles.alertSuccess)}>
                                <div className={styles.alertTitle}>Your export is ready</div>
                                <div className={styles.alertText}>
                                    <a className={styles.zipLink} href={zipUrl} target="_blank" rel="noreferrer">
                                        Click here to download ZIP archive
                                    </a>
                                    <div className={styles.hint}>
                                        You can click “Download All” again to generate a new archive.
                                    </div>
                                </div>
                            </div>
                        )}

                        {isFailed && (
                            <div className={classNames(styles.bulkExportAlert, styles.alertError)}>
                                <div className={styles.alertTitle}>Export failed</div>
                                <div className={styles.alertText}>Please try again by clicking “Download All”.</div>
                            </div>
                        )}

                        {downloadStatus === 'error' && (
                            <div className={classNames(styles.bulkExportAlert, styles.alertError)}>
                                <div className={styles.alertTitle}>Status check error</div>
                                <div className={styles.alertText}>{downloadError ?? 'Unknown error'}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default ProgramBookGraphScreen;
